/* =================================================================
 *  MONOGRAM  ·  theme asset (GemPages + Kaching companion)
 *
 *  Loader (GemPages "Custom Code" block, near the buy box):
 *    <div id="mngm-monogram"></div>
 *    <script src="<asset url>" defer></script>
 *
 *  Reproduces the original PDP monogram popup:
 *   - Reads the SELECTED Kaching bundle (2 / 4 / 6 blankets)
 *   - "ADD MONOGRAM" button -> modal to pick which blanket
 *   - detail step (font / color / text / live preview) -> Save
 *   - terms + total + Done; button becomes "EDIT MONOGRAM · N added"
 *   - on Add to cart, adds one $ monogram line item per saved blanket
 *  No own add-to-cart button: it hooks the page's add-to-cart.
 * ================================================================= */
(function () {
  'use strict';

  var CONFIG = {
    monogramHandle: 'monogram-test-product',        // $ add-on product
    blanketHandle:  'the-monogrammed-muslin-blanket',
    maxChars: 10,
    containerId: 'mngm-monogram',
    defaultImage: 'https://cdn.shopify.com/s/files/1/0872/8906/9899/files/Cotton_Blanket-Khaki_02_2_f4687a18-70ff-40bb-9f43-ddb217ce0ff7.webp',
    fonts: [
      { label: 'Classic Serif',  value: 'Playfair Display', css: '"Playfair Display", serif',  size: 30 },
      { label: 'Elegant Script', value: 'Pinyon Script',    css: '"Pinyon Script", cursive',   size: 40 }
    ],
    colors: [
      { label: 'Black', value: 'Black', css: '#111111' },
      { label: 'White', value: 'White', css: '#ffffff' }
    ],
    processingNotice: 'Please note Monogrammed items take an additional 4-6 business days for processing.',
    termsText: 'I have double checked all of my information and understand monogram items are not eligible for return or exchange.'
  };

  var CUR_SYMBOLS = { USD: '$', GBP: '£', EUR: '€', CAD: '$', AUD: '$', NZD: '$' };

  var root, monogram = null, imageByColor = {}, slots = [], data = [], curEdit = -1;
  var elSelect, elDetail, selfAdd = false, addedRecently = false;
  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  /* ---------- helpers ---------- */
  function money(baseCents) {
    try {
      var c = window.Shopify && window.Shopify.currency;
      if (c && c.active && c.rate) {
        var sym = CUR_SYMBOLS[c.active] || '';
        return sym + (baseCents / 100 * parseFloat(c.rate)).toFixed(2);
      }
    } catch (e) {}
    return '$' + (baseCents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function isCartAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }
  function fontLabel(v) { var f = CONFIG.fonts.find(function (x) { return x.value === v; }); return f ? f.label : v; }
  function completedCount() { return data.filter(function (d) { return d && d.completed && (d.text || '').trim(); }).length; }
  function imgFor(color) { return imageByColor[color] || CONFIG.defaultImage; }

  /* ---------- Kaching reading ---------- */
  function selectedBar() {
    var bars = document.querySelector('.kaching-bundles__bars');
    if (!bars) return null;
    var sel = bars.querySelector('.kaching-bundles__bar--selected');
    if (sel) return sel;
    var radio = bars.querySelector('input[type="radio"]:checked');
    if (radio && radio.closest) { var b = radio.closest('.kaching-bundles__bar'); if (b) return b; }
    return bars.querySelector('.kaching-bundles__bar');
  }
  function readBundle() {
    var bar = selectedBar();
    if (!bar) { console.log('[Monogram] no selected bundle bar yet'); return []; }
    var wraps = bar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper');
    var out = Array.prototype.map.call(wraps, function (w, i) {
      var numEl = w.querySelector('.kaching-bundles__bar-variant-number');
      var num = numEl ? (numEl.textContent.match(/\d+/) || [String(i + 1)])[0] : String(i + 1);
      var colorSel = w.querySelector('select[data-name="Color"], select[data-name="Colour"]') ||
                     w.querySelector('select.kaching-bundles__bar-variant-select');
      var sizeSel = w.querySelector('select[data-name^="Size"]');
      return { number: String(num), blanketColor: colorSel ? colorSel.value : '', size: sizeSel ? sizeSel.value : '' };
    });
    console.log('[Monogram] bundle read:', out.length, 'blanket(s) ->', JSON.stringify(out));
    return out;
  }
  function syncSlots() {
    var next = readBundle();
    var changed = next.length !== slots.length ||
      next.some(function (n, i) { return !slots[i] || slots[i].blanketColor !== n.blanketColor || slots[i].size !== n.size; });
    slots = next;
    // keep data length in sync (preserve by index)
    for (var i = 0; i < slots.length; i++) if (!data[i]) data[i] = emptyData();
    data.length = slots.length;
    if (changed) { renderTrigger(); if (isOpen(elSelect)) buildGrid(); }
  }
  function emptyData() { return { completed: false, font: CONFIG.fonts[0].value, textColor: CONFIG.colors[0].value, text: '' }; }

  /* ---------- trigger button ---------- */
  function renderTrigger() {
    if (!slots.length) { root.innerHTML = ''; return; }
    var n = completedCount();
    root.innerHTML =
      '<button type="button" class="mg-trigger">' +
        '<span class="mg-trigger-label">' + (n ? 'EDIT MONOGRAM' : 'ADD MONOGRAM') + '</span>' +
        (n ? '<span class="mg-trigger-count">' + n + ' added</span>' : '') +
      '</button>';
    root.querySelector('.mg-trigger').addEventListener('click', openSelection);
  }

  /* ---------- modals ---------- */
  function isOpen(el) { return el && !el.hidden; }
  function hide(el) { if (el) el.hidden = true; }
  function show(el) { if (el) el.hidden = false; }

  function ensureModals() {
    if (elSelect) return;
    var fontOpts = CONFIG.fonts.map(function (x) { return '<option value="' + esc(x.value) + '">' + esc(x.label) + '</option>'; }).join('');
    var colorOpts = CONFIG.colors.map(function (x) { return '<option value="' + esc(x.value) + '">' + esc(x.label) + '</option>'; }).join('');

    elSelect = document.createElement('div');
    elSelect.className = 'mg-overlay'; elSelect.hidden = true;
    elSelect.innerHTML =
      '<div class="mg-modal">' +
        '<div class="mg-mhead">' +
          '<div><h3 class="mg-title">Add Monogram</h3><p class="mg-note">' + esc(CONFIG.processingNotice) + '</p></div>' +
          '<button type="button" class="mg-x mg-close">&times;</button>' +
        '</div>' +
        '<div class="mg-mbody"><p class="mg-sub">Select a blanket to add monogram. Each blanket can have its own custom message.</p><div class="mg-grid"></div></div>' +
        '<div class="mg-mfoot mg-select-foot" hidden>' +
          '<label class="mg-terms"><input type="checkbox" class="mg-terms-cb"> <span>' + esc(CONFIG.termsText) + '</span></label>' +
          '<div class="mg-total">Total: <span class="mg-total-v">' + money(0) + '</span></div>' +
          '<button type="button" class="mg-btn mg-done" disabled>DONE</button>' +
        '</div>' +
      '</div>';

    elDetail = document.createElement('div');
    elDetail.className = 'mg-overlay'; elDetail.hidden = true;
    elDetail.innerHTML =
      '<div class="mg-modal">' +
        '<div class="mg-mhead"><button type="button" class="mg-back">&#8249; Back</button><button type="button" class="mg-x mg-close">&times;</button></div>' +
        '<div class="mg-mbody mg-detail-body">' +
          '<div class="mg-preview"><img class="mg-prev-img" alt=""><span class="mg-prev-text"></span></div>' +
          '<div class="mg-detail-form">' +
            '<h4 class="mg-dtitle">MONOGRAM <span class="mg-dnum"></span></h4>' +
            '<label class="mg-label">FONT STYLE</label><select class="mg-dfont">' + fontOpts + '</select>' +
            '<label class="mg-label">TEXT COLOR</label><select class="mg-dcolor">' + colorOpts + '</select>' +
            '<label class="mg-label">MONOGRAM TEXT</label><input type="text" class="mg-dtext" maxlength="' + CONFIG.maxChars + '" placeholder="Enter text (max ' + CONFIG.maxChars + ' chars)" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
          '</div>' +
        '</div>' +
        '<div class="mg-mfoot"><div class="mg-dprice">Price: <span class="mg-dprice-v">' + money(monogram.price) + '</span></div><button type="button" class="mg-btn mg-save" disabled>SAVE MONOGRAM</button></div>' +
      '</div>';

    document.body.appendChild(elSelect);
    document.body.appendChild(elDetail);

    // selection wiring
    elSelect.querySelector('.mg-close').addEventListener('click', closeAll);
    elSelect.addEventListener('click', function (e) { if (e.target === elSelect) closeAll(); });
    elSelect.querySelector('.mg-terms-cb').addEventListener('change', updateSelectFooter);
    elSelect.querySelector('.mg-done').addEventListener('click', function () { closeAll(); });

    // detail wiring
    elDetail.querySelector('.mg-close').addEventListener('click', closeAll);
    elDetail.querySelector('.mg-back').addEventListener('click', openSelection);
    var dtext = elDetail.querySelector('.mg-dtext');
    var dfont = elDetail.querySelector('.mg-dfont');
    var dcolor = elDetail.querySelector('.mg-dcolor');
    [dtext, dfont, dcolor].forEach(function (el) { el.addEventListener('input', onDetailChange); el.addEventListener('change', onDetailChange); });
    elDetail.querySelector('.mg-save').addEventListener('click', saveDetail);
  }

  function openSelection() {
    ensureModals();
    syncSlots();          // fresh read so the grid always matches the currently selected deal
    hide(elDetail);
    buildGrid();
    show(elSelect);
  }

  function buildGrid() {
    var grid = elSelect.querySelector('.mg-grid');
    grid.innerHTML = slots.map(function (s, i) {
      var d = data[i] || {}; var done = d.completed && (d.text || '').trim();
      return '' +
        '<button type="button" class="mg-card' + (done ? ' done' : '') + '" data-i="' + i + '">' +
          (done ? '<span class="mg-remove" data-remove="' + i + '">&minus;</span>' : '') +
          '<span class="mg-card-title">Add MONOGRAM ' + esc(s.number) + ' for <strong>' + esc(s.blanketColor || '') + '</strong></span>' +
          '<span class="mg-card-price">+' + money(monogram.price) + '</span>' +
        '</button>';
    }).join('');

    grid.querySelectorAll('.mg-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        var i = +card.getAttribute('data-i');
        if (e.target.classList.contains('mg-remove')) { e.stopPropagation(); data[i] = emptyData(); buildGrid(); updateSelectFooter(); renderTrigger(); return; }
        openDetail(i);
      });
    });
    updateSelectFooter();
  }

  function updateSelectFooter() {
    var foot = elSelect.querySelector('.mg-select-foot');
    var n = completedCount();
    foot.hidden = n === 0;
    elSelect.querySelector('.mg-total-v').textContent = money(monogram.price * n);
    var terms = elSelect.querySelector('.mg-terms-cb');
    elSelect.querySelector('.mg-done').disabled = !(n > 0 && terms.checked);
    renderTrigger();
  }

  function openDetail(i) {
    curEdit = i;
    var s = slots[i] || {}, d = data[i] || emptyData();
    elDetail.querySelector('.mg-dnum').textContent = s.number || String(i + 1);
    elDetail.querySelector('.mg-prev-img').src = imgFor(s.blanketColor);
    elDetail.querySelector('.mg-dfont').value = d.font;
    elDetail.querySelector('.mg-dcolor').value = d.textColor;
    elDetail.querySelector('.mg-dtext').value = d.text;
    updateDetailPreview();
    hide(elSelect); show(elDetail);
  }

  function onDetailChange() { updateDetailPreview(); }

  function updateDetailPreview() {
    var t = (elDetail.querySelector('.mg-dtext').value || '').trim();
    var fontVal = elDetail.querySelector('.mg-dfont').value;
    var colorVal = elDetail.querySelector('.mg-dcolor').value;
    var f = CONFIG.fonts.find(function (x) { return x.value === fontVal; }) || CONFIG.fonts[0];
    var c = CONFIG.colors.find(function (x) { return x.value === colorVal; }) || CONFIG.colors[0];
    var pt = elDetail.querySelector('.mg-prev-text');
    pt.textContent = t;
    pt.style.fontFamily = f.css; pt.style.fontSize = f.size + 'px'; pt.style.color = c.css;
    pt.style.display = t ? 'block' : 'none';
    elDetail.querySelector('.mg-save').disabled = !t;
  }

  function saveDetail() {
    var i = curEdit; if (i < 0) return;
    data[i] = {
      completed: true,
      font: elDetail.querySelector('.mg-dfont').value,
      textColor: elDetail.querySelector('.mg-dcolor').value,
      text: (elDetail.querySelector('.mg-dtext').value || '').trim()
    };
    openSelection();
  }

  function closeAll() { hide(elSelect); hide(elDetail); renderTrigger(); }

  /* ---------- cart hook ---------- */
  function hookCart() {
    if (origFetch) {
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var trigger = isCartAdd(url) && !selfAdd;
        var res = origFetch(input, init);
        if (trigger) res.then(function () { maybeAddMonograms(); }).catch(function () {});
        return res;
      };
    }
    var OpenOrig = XMLHttpRequest.prototype.open, SendOrig = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__mCartAdd = isCartAdd(u); return OpenOrig.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__mCartAdd && !selfAdd) this.addEventListener('load', function () { maybeAddMonograms(); });
      return SendOrig.apply(this, arguments);
    };
  }

  function maybeAddMonograms() {
    if (addedRecently) return;
    var items = [];
    data.forEach(function (d, i) {
      if (d && d.completed && (d.text || '').trim()) {
        var s = slots[i] || {};
        items.push({
          id: monogram.variants[0].id, quantity: 1,
          properties: {
            'Monogram Text':  d.text.trim(),
            'Monogram Style': fontLabel(d.font),
            'Monogram Color': d.textColor,
            'For Blanket':    '#' + (s.number || (i + 1)) + (s.blanketColor ? ' · ' + s.blanketColor : '') + (s.size ? ' · ' + s.size : ''),
            '_monogram': 'true'
          }
        });
      }
    });
    if (!items.length) return;

    addedRecently = true;
    setTimeout(function () { addedRecently = false; }, 4000);

    selfAdd = true;
    (origFetch || window.fetch)('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function () {
      selfAdd = false;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    })
    .catch(function (e) { selfAdd = false; addedRecently = false; console.error('[Monogram] add failed', e); });
  }

  /* ---------- assets ---------- */
  function injectHead() {
    if (document.getElementById('mngm-assets')) return;
    var meta = document.createElement('meta'); meta.id = 'mngm-assets'; document.head.appendChild(meta);
    var f = document.createElement('link'); f.rel = 'stylesheet';
    f.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600&family=Pinyon+Script&display=swap';
    document.head.appendChild(f);
    var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s);
  }

  /* ---------- boot ---------- */
  function watchKaching() {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var bars = document.querySelector('.kaching-bundles__bars');
      if (bars) {
        clearInterval(iv);
        syncSlots();
        bars.addEventListener('change', function () { setTimeout(syncSlots, 60); });
        try {
          var mo = new MutationObserver(function () { clearTimeout(watchKaching._t); watchKaching._t = setTimeout(syncSlots, 120); });
          mo.observe(bars, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-value'] });
        } catch (e) {}
      } else if (tries > 60) { clearInterval(iv); console.warn('[Monogram] Kaching bundle not found'); }
    }, 400);
  }

  function boot() {
    root = document.getElementById(CONFIG.containerId);
    if (!root) { console.error('[Monogram] #' + CONFIG.containerId + ' not found'); return; }
    injectHead();
    hookCart();
    var get = function (h) { return fetch('/products/' + h + '.js', { headers: { 'Content-Type': 'application/json' } }).then(function (r) { return r.json(); }); };
    Promise.all([get(CONFIG.monogramHandle), get(CONFIG.blanketHandle).catch(function () { return null; })])
      .then(function (res) {
        monogram = res[0];
        var bp = res[1];
        if (bp && bp.variants) bp.variants.forEach(function (v) {
          var color = v.option1; var src = v.featured_image && v.featured_image.src;
          if (color && src && !imageByColor[color]) imageByColor[color] = (src.indexOf('//') === 0 ? 'https:' + src : src);
        });
        var firstImg = Object.keys(imageByColor)[0];
        if (firstImg) CONFIG.defaultImage = imageByColor[firstImg];
        console.log('[Monogram] blanket images loaded for colors:', Object.keys(imageByColor).join(', ') || '(none)');
        watchKaching();
      })
      .catch(function (e) { console.error('[Monogram] product load failed', e); });
  }

  /* ---------- styles ---------- */
  var CSS =
    '#mngm-monogram{font-family:inherit}' +
    '#mngm-monogram .mg-trigger{width:100%;padding:16px;border:1px solid #cfcabf;border-radius:12px;background:#f6f3ee;cursor:pointer;font-weight:700;letter-spacing:.03em;text-transform:uppercase;color:#1a1a1a;display:flex;flex-direction:column;align-items:center;gap:2px}' +
    '#mngm-monogram .mg-trigger:hover{background:#efe9e0}' +
    '#mngm-monogram .mg-trigger-count{font-size:12px;font-weight:500;text-transform:none;letter-spacing:0;color:#7a7a7a}' +
    '.mg-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;padding:16px;font-family:inherit;color:#1a1a1a}' +
    '.mg-overlay *{box-sizing:border-box}' +
    '.mg-modal{background:#fff;border-radius:16px;width:100%;max-width:720px;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.3)}' +
    '.mg-mhead{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:20px 24px;border-bottom:1px solid #eee}' +
    '.mg-title{margin:0;font-size:22px;font-weight:700}' +
    '.mg-note{margin:6px 0 0;font-size:13px;font-weight:700;line-height:1.3}' +
    '.mg-x{background:none;border:none;font-size:26px;line-height:1;cursor:pointer;color:#444;flex:none}' +
    '.mg-back{background:none;border:none;font-size:16px;cursor:pointer;color:#444;display:flex;align-items:center;gap:4px}' +
    '.mg-mbody{padding:24px;overflow-y:auto}' +
    '.mg-sub{text-align:center;color:#333;font-size:15px;margin:0 0 20px;line-height:1.5}' +
    '.mg-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px}' +
    '@media(max-width:560px){.mg-grid{grid-template-columns:1fr}}' +
    '.mg-card{position:relative;border:1px solid #cfcabf;border-radius:12px;padding:22px 16px;background:#fff;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:6px;text-align:center}' +
    '.mg-card:hover{border-color:#1a1a1a}' +
    '.mg-card.done{border-color:#3aae5a;background:#f2fbf4}' +
    '.mg-card-title{font-size:15px}.mg-card-price{font-size:13px;color:#7a7a7a}' +
    '.mg-remove{position:absolute;top:-10px;right:-10px;width:26px;height:26px;border-radius:50%;background:#e74c3c;color:#fff;display:flex;align-items:center;justify-content:center;font-size:20px;line-height:1}' +
    '.mg-mfoot{padding:16px 24px;border-top:1px solid #eee;display:flex;flex-direction:column;gap:12px}' +
    '.mg-terms{display:flex;gap:10px;font-size:13px;color:#444;line-height:1.4;cursor:pointer}.mg-terms input{margin-top:2px;flex:none;width:18px;height:18px}' +
    '.mg-total,.mg-dprice{text-align:center;font-size:20px;font-weight:700}' +
    '.mg-btn{width:100%;padding:16px;border:none;border-radius:12px;background:#1a1a1a;color:#fff;font-weight:700;letter-spacing:.03em;text-transform:uppercase;cursor:pointer}' +
    '.mg-btn:disabled{opacity:.4;cursor:not-allowed}' +
    '.mg-detail-body{display:grid;grid-template-columns:1fr 1fr;gap:24px}@media(max-width:560px){.mg-detail-body{grid-template-columns:1fr}}' +
    '.mg-preview{position:relative;border-radius:12px;overflow:hidden;background:#f4f1ec;aspect-ratio:1/1}' +
    '.mg-prev-img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.mg-prev-text{position:absolute;top:50%;left:42%;transform:translate(-50%,-50%);white-space:nowrap;line-height:1;pointer-events:none;text-shadow:0 1px 2px rgba(0,0,0,.12)}' +
    '.mg-dtitle{margin:0 0 14px;font-size:18px;font-weight:700}' +
    '.mg-label{display:block;font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:#666;margin:12px 0 6px}' +
    '.mg-detail-form select,.mg-detail-form input{width:100%;padding:12px 14px;font-size:15px;border:1px solid #d9d5cd;border-radius:10px;background:#fff;color:#1a1a1a}';

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
